var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-dialog" }, [
    this.update
      ? _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h5",
              {
                staticClass: "modal-title",
                attrs: { id: "newTableModalLabel" },
              },
              [_vm._v("Update Table")]
            ),
            _c("button", {
              staticClass: "btn-close",
              attrs: { type: "button", "data-bs-dismiss": "modal" },
              on: { click: _vm.clear },
            }),
          ]),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "mt-3" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "TableName" } },
                [_vm._v("Table Name")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name",
                  },
                ],
                staticClass: "form-control pl-3",
                attrs: {
                  type: "text",
                  id: "TableName",
                  "aria-describedby": "emailHelp",
                },
                domProps: { value: _vm.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.name = $event.target.value
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "mt-3" }, [
              _c(
                "label",
                {
                  staticClass: "form-label w-100",
                  attrs: { for: "TableName" },
                },
                [_vm._v("Is VIP?")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isVIP,
                    expression: "isVIP",
                  },
                ],
                staticClass: "btn pl-3",
                attrs: {
                  type: "checkbox",
                  id: "TableName",
                  "aria-describedby": "emailHelp",
                },
                domProps: {
                  checked: Array.isArray(_vm.isVIP)
                    ? _vm._i(_vm.isVIP, null) > -1
                    : _vm.isVIP,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.isVIP,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.isVIP = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.isVIP = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.isVIP = $$c
                    }
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "mt-3" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "Details" } },
                [_vm._v("Location Details")]
              ),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.locationDetails,
                    expression: "locationDetails",
                  },
                ],
                staticClass: "form-control pl-3",
                attrs: {
                  placeholder: "Leave a comment here",
                  id: "floatingTextarea",
                },
                domProps: { value: _vm.locationDetails },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.locationDetails = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.saveItem()
                  },
                },
              },
              [_vm._v("Save changes")]
            ),
          ]),
        ])
      : _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h5",
              {
                staticClass: "modal-title",
                attrs: { id: "newTableModalLabel" },
              },
              [_vm._v("Add Tables")]
            ),
            _c("button", {
              staticClass: "btn-close",
              attrs: { type: "button", "data-bs-dismiss": "modal" },
              on: { click: _vm.clear },
            }),
          ]),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "mt-3" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "TableName" } },
                [_vm._v("How Many Tables?")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.numberOfTables,
                    expression: "numberOfTables",
                  },
                ],
                staticClass: "form-control pl-3",
                attrs: {
                  type: "text",
                  id: "TableName",
                  "aria-describedby": "emailHelp",
                },
                domProps: { value: _vm.numberOfTables },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.numberOfTables = $event.target.value
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "mt-3" }, [
              _c(
                "label",
                {
                  staticClass: "form-label w-100",
                  attrs: { for: "TableName" },
                },
                [_vm._v("VIP Tables?")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isVIP,
                    expression: "isVIP",
                  },
                ],
                staticClass: "btn pl-3",
                attrs: {
                  type: "checkbox",
                  id: "TableName",
                  "aria-describedby": "emailHelp",
                },
                domProps: {
                  checked: Array.isArray(_vm.isVIP)
                    ? _vm._i(_vm.isVIP, null) > -1
                    : _vm.isVIP,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.isVIP,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.isVIP = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.isVIP = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.isVIP = $$c
                    }
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", "data-bs-dismiss": "modal" },
                on: { click: _vm.clear },
              },
              [_vm._v("Close")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.saveItem()
                  },
                },
              },
              [_vm._v("Save changes")]
            ),
          ]),
        ]),
    _c(
      "button",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "close",
        staticClass: "btn btn-secondary",
        attrs: { type: "button", "data-bs-dismiss": "modal" },
      },
      [_vm._v("Close")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }